 import React, { useState, useEffect } from 'react';
import withRouter from '../../Components/Common/withRouter';
import { LOCAL_BACKGROUNDS, checkImageLoad } from './backgroundUtils';

// Lista de imágenes de fondo con licencias permisivas y URLs confiables
// Usando Unsplash (permite hotlinking con atribución)
// Estilo profesional: gradientes abstractos azules y morados
const BACKGROUND_IMAGES = [

  {
    url: "https://images.unsplash.com/photo-1618556450994-a6a128ef0d9d?w=2070&q=80",
    title: "Mesh gradient azul",
    author: "Pawel Czerwinski"
  },
  {
    url: "https://images.unsplash.com/photo-1620121692029-d088224ddc74?w=2070&q=80",
    title: "Gradiente moderno",
    author: "Milad Fakurian"
  },
  {
    url: "https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?w=2070&q=80",
    title: "Fluido digital",
    author: "Pawel Czerwinski"
  },
  {
    url: "https://images.unsplash.com/photo-1636955816868-fcb881e57954?w=2070&q=80",
    title: "Gradiente tecnológico",
    author: "Gradienta"
  },

  {
    url: "https://images.unsplash.com/photo-1618556450994-a6a128ef0d9d?w=2070&q=80",
    title: "Gradiente azul profundo",
    author: "Pawel Czerwinski"
  }
];

const ParticlesAuth = ({ children }) => {
    const [backgroundImage, setBackgroundImage] = useState(null);
    const [imageIndex, setImageIndex] = useState(0);
    const [useLocalFallback, setUseLocalFallback] = useState(false);

    useEffect(() => {
        const loadBackground = async () => {
            // Intentar cargar una imagen aleatoria de Unsplash
            const randomIndex = Math.floor(Math.random() * BACKGROUND_IMAGES.length);
            const selectedImage = BACKGROUND_IMAGES[randomIndex];
            
            try {
                // Verificar si la imagen se puede cargar
                const canLoad = await checkImageLoad(selectedImage.url);
                
                if (canLoad) {
                    setBackgroundImage(selectedImage);
                    setImageIndex(randomIndex);
                    setUseLocalFallback(false);
                } else {
                    // Si falla, usar un gradiente local
                    const localIndex = Math.floor(Math.random() * LOCAL_BACKGROUNDS.length);
                    setBackgroundImage(LOCAL_BACKGROUNDS[localIndex]);
                    setUseLocalFallback(true);
                }
            } catch (error) {
                // En caso de error, usar gradiente local
                const localIndex = Math.floor(Math.random() * LOCAL_BACKGROUNDS.length);
                setBackgroundImage(LOCAL_BACKGROUNDS[localIndex]);
                setUseLocalFallback(true);
            }
        };

        loadBackground();
    }, []);


    // Estilo dinámico para el fondo
    const backgroundStyle = backgroundImage ? {
        backgroundImage: useLocalFallback ? backgroundImage.style : `url("${backgroundImage.url}")`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        transition: "background-image 0.5s ease-in-out"
    } : {};

    return (
        <React.Fragment>
            <div className="auth-page-wrapper pt-5">
                {/* Contenedor de fondo con estilos inline - sin clases CSS */}
            <div 
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    width: "100%",
                    height: "100vh",
                    zIndex: -1,
                    ...backgroundStyle
                }}
            >
                    {/* Sin overlay para mostrar imagen en color original */}

                    {/* Shape eliminado para mostrar imagen completa sin onda blanca */}

                </div>

                {/* Contenido del formulario - fuera del div de fondo */}
                <div style={{ position: "relative", zIndex: 1 }}>
                    {children}
                </div>

                <footer className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <p className="mb-0 text-muted">
                                        &copy; {new Date().getFullYear()} Farme. 
                                        {backgroundImage && (
                                            <span className="ms-2">
                                                <small className="text-muted">
                                                    Fondo: {backgroundImage.title} {useLocalFallback ? '(Local)' : `(Foto por ${backgroundImage.author})`}
                                                </small>
                                            </span>
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </React.Fragment>
    );
};

export default withRouter(ParticlesAuth);